import { Modal, ModalOverlay, ModalContent } from "@chakra-ui/react";
import { BackButton } from "ui/pages/app/components/buttons/BackButton";
import { translate } from "ui/i18n";
import { PrimaryButton } from "ui/pages/app/components/buttons/PrimaryButton";
import { useWindowWidth } from "ui/utils/hooks";
import { HiFolderOpen, HiPencilAlt } from "react-icons/hi";
import { DeleteFolder } from "ui/assets/svg/DeleteFolder";
import { Snackbar } from "ui/pages/snackbar";
import { deleteFolder } from "domain/folders/folders.actions";
import { useAppDispatch } from "ui/hook/store";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  folderId: number;
  removeSelectedFolder: () => void;
}

export function ModalDeleteFolder({
  isOpen,
  onClose,
  folderId,
  removeSelectedFolder,
}: IProps) {
  const isDesktop = useWindowWidth();
  const dispatch = useAppDispatch();

  const handleDeleteClick = async () => {
    const result = await dispatch(deleteFolder(folderId)).unwrap();
    if (result.success) {
      Snackbar.showSuccess({
        title: translate("ns1:Folders.FolderDeleted"),
      });
      removeSelectedFolder();
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent maxW="750px" margin="20px" className="!rounded-[30px] p-8">
        <BackButton onClick={onClose} />
        <div className="mt-12 flex flex-col items-center">
          <h4 className="w-fit text-center font-bold text-secondaryGrey-900">
            {translate("ns1:Folders.ModalDeleteTitle")}
          </h4>

          <span className="mt-4 text-center text-base font-medium text-secondaryGrey-900">
            {translate("ns1:Folders.ModalDeleteSubtitle")}
          </span>

          <div className="mt-10" style={{ maxWidth: 600, width: "100%" }}>
            <DeleteFolder />
          </div>
        </div>

        <div className="mt-10">
          <PrimaryButton
            height={isDesktop ? "52px" : "46px"}
            width="100%"
            onClick={handleDeleteClick}
          >
            <HiPencilAlt color="#fff" size={20} className="me-2" />
            {translate("ns1:Folders.DeleteThisFolder")}
          </PrimaryButton>

          <PrimaryButton
            height={isDesktop ? "52px" : "46px"}
            width="100%"
            className="mt-4 md:mt-6"
            onClick={() => onClose()}
            outlined
          >
            <HiFolderOpen color="#2D396B" size={20} className="me-2" />
            {translate("ns1:Folders.KeepThisFolder")}
          </PrimaryButton>
        </div>
      </ModalContent>
    </Modal>
  );
}
